// Popisky doplnkového menu topbaru — slovenské dvojče locale/cs/topBarLinks.js.
export default {
  blog: 'Blog',
  b2b: 'Veľkoobchod',
  service: 'Servis náradia',
  store: 'Predajňa náradia',
  shipping: 'Doprava a platba',
  contact: 'Kontakt',
  orderStatus: 'Stav objednávky',
  nav: 'Informácie',
};
